var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{ref:"child",attrs:{"showCurrency":_vm.showCurrency,"selectedCountry":_vm.selectedCountry,"countries":_vm.countries}})
}
var staticRenderFns = []

export { render, staticRenderFns }